var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.list),function(form,index){return _c('preparation-form',{key:index,ref:`preparationForm${index}`,refInFor:true,attrs:{"model":_vm.list[index],"title":_vm.title,"withLabel":index === 0},on:{"remove":function($event){return _vm.handleRemove(index)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }